import type { ISessionSlot } from "@/types/formation";

/** First upcoming session matching one of the given session types (e.g. presentiel, distanciel). */
export function getNextSessionByType(
  sessions: ISessionSlot[],
  types: string[]
): ISessionSlot | undefined {
  const now = new Date();

  return sessions
    .filter((s): s is ISessionSlot & { start_date: string } =>
      Boolean(s.start_date) && types.includes(s.session_type) && new Date(s.start_date as string) >= now
    )
    .sort((a, b) => new Date(a.start_date).getTime() - new Date(b.start_date).getTime())[0];
}
